import React from 'react';

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48">
    <path d="M12.65 36.45 11.55 35.35 22.9 24 11.55 12.65 12.65 11.55 24 22.9 35.35 11.55 36.45 12.65 25.1 24 36.45 35.35 35.35 36.45 24 25.1Z" />
  </svg>
);

export default CloseIcon;
